import { Scene, WebGLRenderer, PerspectiveCamera } from "three";
import { StereoEffect } from "three/examples/jsm/effects/StereoEffect";
import CurrentPlayer from "./Player/CurrentPlayer";
import Loader from "./Loader";
import World from "./World";
import Auth from "./Auth";
import CurrentPlayerOnline from "./Player/CurrentPlayerOnline";
import AudioManager from "./AudioManager";

class Game {
    public currentPlayer: CurrentPlayer;

    public prevTime: number;

    public scene: Scene;

    public world: World;

    public renderer: WebGLRenderer;

    public effect: StereoEffect;

    public camera: PerspectiveCamera;

    public loader: Loader;

    public isFullscreen: boolean;

    public currentPlayerOnline: CurrentPlayerOnline;

    public audio: AudioManager;

    constructor(auth: Auth) {
        const currentPlayerId = auth.getCurrentPlayerId();
        this.loader = new Loader();
        this.scene = new Scene();
        this.world = new World(this.scene, this.loader, currentPlayerId);

        this.camera = new PerspectiveCamera(
            80,
            window.innerWidth / window.innerHeight,
            0.001,
            this.world.fogFar
        );

        this.currentPlayer = new CurrentPlayer(
            this.camera,
            this.scene,
            this.loader,
            this.world,
            currentPlayerId,
            null
        );

        this.prevTime = performance.now();
        this.renderer = new WebGLRenderer({ antialias: true });

        this.effect = new StereoEffect(this.renderer);
        this.effect.setSize(window.innerWidth, window.innerHeight);

        this.currentPlayerOnline = new CurrentPlayerOnline(
            this.currentPlayer,
            auth.getCurrentPlayerId(),
            auth.getCurrentPlayerName()
        );

        // World

        // Display
        this.isFullscreen = false;

        // Sound
        this.audio = new AudioManager();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public update(delta: number): void {
        this.currentPlayerOnline.update();
    }
}

export default Game;
